import { Table as MantineTable, Skeleton } from '@mantine/core';
import { type FC } from 'react';
import { type TableCell } from '../../types';

interface SkeletonsProps {
    head: TableCell[];
}

export const Skeletons: FC<SkeletonsProps> = ({ head }) => {
    return Array.from(Array(5).keys()).map((el) => {
        return (
            <MantineTable.Tr key={el}>
                {head.map(({ key }) => {
                    return (
                        <MantineTable.Td key={key}>
                            <Skeleton h={24} />
                        </MantineTable.Td>
                    );
                })}
            </MantineTable.Tr>
        );
    });
};
